module.exports = __webpack_public_path__ + "static/media/triangle3.a2590363.svg";